export default {
  getX (slide, i, flkty) {
    var x = (slide.target + flkty.x)
    // NOTE: the following works good when wraparound is true
    // if (i === 0 && Math.abs(flkty.x) > flkty.slidesWidth) {
    //   x = (flkty.slidesWidth + flkty.x + flkty.slides[flkty.slides.length - 1].outerWidth + slide.target)
    // } else if (i === flkty.slides.length - 1 && Math.abs(flkty.x) + flkty.slides[i].outerWidth < flkty.slidesWidth) {
    //   x = (slide.target - flkty.slidesWidth + flkty.x - flkty.slides[i].outerWidth)
    // }
    return x
  },
}



// WEBPACK FOOTER //
// ./scripts/util/flickityHelpers.js